
const benefits = [
  {
    icon: 'ri-smartphone-line',
    title: 'Built for mobile first',
    description: 'Your customers are on their phones. Your site needs to work perfectly there.'
  },
  {
    icon: 'ri-phone-line',
    title: 'Clear booking & call flows',
    description: 'Every page has one goal: get them to call or book. No confusion.'
  },
  {
    icon: 'ri-search-2-line',
    title: 'Optimized for local SEO',
    description: 'Show up when people in your area search for your services.'
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Integrated lead capture forms',
    description: 'Capture every potential customer. No lead left behind.'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Fast loading, clean design',
    description: 'Speed matters. Clean design converts. We deliver both.'
  }
];

export default function Solution() {
  return (
    <section className="py-24 px-6 bg-[#0A0A0A] relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#3B82F6]/5 rounded-full blur-[150px]"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-16">
          We Build <span className="text-[#3B82F6]">Websites That Work.</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-[#151515] border-2 border-[#3B82F6]/20 rounded-xl p-8 hover:border-[#3B82F6] transition-all hover:shadow-lg hover:shadow-[#3B82F6]/10"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#3B82F6]/10 rounded-xl mb-6">
                <i className={`${benefit.icon} text-3xl text-[#3B82F6]`}></i>
              </div>
              <h3 className="text-xl font-black mb-3 text-white">{benefit.title}</h3>
              <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
